"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstLunarSettlement = void 0;
const CardName_1 = require("../../CardName");
const Tags_1 = require("../Tags");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Resources_1 = require("../../Resources");
const PlaceMoonColonyTile_1 = require("../../moon/PlaceMoonColonyTile");
const CardRenderer_1 = require("../render/CardRenderer");
const TileType_1 = require("../../TileType");
const CardRenderItem_1 = require("../render/CardRenderItem");
class FirstLunarSettlement extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.FIRST_LUNAR_SETTLEMENT,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.MOON],
            metadata: {
                description: 'Place a colony tile on the Moon and Raise the Colony Rate 1 step. Increase your M€ production 1 step.',
                cardNumber: 'MP1',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(1)).moonColony().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_COLONY_RATE);
                }),
            },
        });
        this.tilesBuilt = [TileType_1.TileType.MOON_COLONY];
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1, { log: true });
        player.game.defer(new PlaceMoonColonyTile_1.PlaceMoonColonyTile(player));
        return undefined;
    }
}
exports.FirstLunarSettlement = FirstLunarSettlement;
//# sourceMappingURL=FirstLunarSettlement.js.map